console.log("trust-messaging.js loaded");

const html = document.documentElement;
const body = document.body;

import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

let trustSwiper;

function initialiseTrustSwiper() {
    if (trustSwiper instanceof Swiper) {
        trustSwiper.destroy();
    }

    if (window.innerWidth < 768) {
        let swiper_options = {
            modules: [Autoplay],
            loop: true,
            allowTouchMove: false,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            },
        };
        trustSwiper = new Swiper(
            document.querySelector("#header_trust_messaging .swiper"),
            swiper_options
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    initialiseTrustSwiper();

    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            initialiseTrustSwiper();
        }, 300);
    });
});
